<template>
    <div class="modal fade" id="updateUserModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="updateUserModalLabel">Add / Update User: <b>{{user.fullName}}</b></h4>
                </div>
                <form method="post" @submit.prevent="updateUser()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Full Name</label>
                            <input v-model="user.fullName" type="text" required="required" class="form-control" placeholder="Full Name..."/>
                        </div>
                        <div class="form-group">
                            <label>Contact</label>
                          <input v-model="user.contact"
                                 required="required"
                                 class="form-control"
                                 id="contactNumber"
                                 type="tel"
                                 pattern="0(3|4)[0-9]{2}[0-9]{7}"
                                 size="11"
                                 placeholder="03xxxxxxxxx or 04xxxxxxxxx">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input v-model="user.email" type="email" class="form-control" required="required" placeholder="Email..."/>
                        </div>
                        <div class="form-group">
                            <label>Username</label>
                            <input v-model="user.username" type="text" required="required" class="form-control" placeholder="Username..."/>
                        </div>
                        <div v-if="user.id === 0" class="form-group">
                            <label>Password</label>
                            <input v-model="user.password" type="password" id="password" required="required" class="form-control" placeholder="Password..."/>
                        </div>
                        <div class="form-group">
                            <label>Enabled</label>
                            <select v-model="user.enabled" required="required" class="form-control">
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Role</label>
                            <select v-model="user.userRolesById[0].role" required="required" class="form-control">
                                <option value="">Select Role</option>
                                <option value="ROLE_ADMIN">ADMIN</option>
                                <option value="ROLE_MANAGER">MANAGER</option>
                                <option value="ROLE_USER">USER</option>
                                <option value="ROLE_AGENT">AGENT</option>
                                <option value="ROLE_BRANCH">BRANCH</option>
                                <option value="ROLE_FRANCHISE">FRANCHISE</option>
                                <option v-if="user.id>0" value="ROLE_RIDER">RIDER</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="user.userRolesById[0].role !== 'ROLE_MANAGER'">
                            <label>Restaurant</label>
                            <select v-model="user.restaurant.id" v-on:change="fetchBranchesOfRestaurant(user.restaurant.id)" class="form-control">
                                <option value="">Select Restaurant</option>
                                <option v-for="restaurant in restaurants" v-bind:key="restaurant.id" v-bind:value="restaurant.id">{{restaurant.name}}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="(user.userRolesById[0].role === 'ROLE_BRANCH' || user.userRolesById[0].role === 'ROLE_RIDER') && user.branch">
                            <label>Branch</label>
                            <select v-model="user.branch.id" class="form-control">
                                <option value="">Select Branch</option>
                                <option v-for="branch in selectedRestaurantBranches" v-bind:key="'branch_' + branch.id" v-bind:value="branch.id">{{branch.areasByAreaId.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="submit" class="btn btn-primary">Save</button>
                </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "UpdateUsers",
        data: function() {
            return {
                restaurants: [],
                selectedRestaurantBranches: [],
                user: {
                    "id": 0,
                    "username": "",
                    "fullName": "",
                    "contact": "",
                    "email": "",
                    "password": "",
                    "created": "",
                    "modified": "",
                    "enabled": true,
                    "contactNumberVerified": true,
                    "userRolesById": [
                        {
                            "id":0,
                            "role": ""
                        }
                    ],
                    "restaurant": {
                        "id": 0
                    },
                    "branch": {
                        "id": 0
                    }
                }
            };
        },
        created: function () {
          this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
             this.restaurants = resp.data;
          });
        },
        mounted: function () {
            $('#updateUserModal').on('hidden.bs.modal',  (e) => {
                if(this.$parent.dtTable !== undefined && this.$parent.dtTable !== null){
                    this.$parent.dtTable.draw();
                }
                this.resetData();
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                    this.restaurants = resp.data;
                });
            });
            this.jQueryOnContactNumberAndPassword();

        },
        methods: {
            load: function (userID){
              if(userID > 0){
                  let params = new URLSearchParams();
                  params.append("user_id", userID);
                  this.$http.post(this.$store.state.mainAppURL + "users/get_user_by_id", params).then(resp => {
                      if(resp.data.restaurant === null){
                          resp.data.restaurant = {};
                          resp.data.restaurant.id = 0;
                      }
                      this.user = resp.data;
                      if(this.user.userRolesById[0].role!=='ROLE_BRANCH' && this.user.userRolesById[0].role!=='ROLE_RIDER' ){
                            this.user.branch={
                                "id":0,
                            };                          
                      }
                      (resp.data.branch && resp.data.restaurant && resp.data.restaurant.id > 0) && (this.fetchBranchesOfRestaurant(this.user.restaurant.id))
                  });
              }
              $("#updateUserModal").modal("show");
            },
            jQueryOnContactNumberAndPassword: function (){
              $("#contactNumber").tooltip({
                trigger: 'hover',
                title: 'Length should be 11',
                placement: 'bottom'
              });
              $("#password").tooltip({
                trigger: 'hover',
                title: 'Minimum Length should be 6',
                placement: 'bottom'
              });
            },
            fetchBranchesOfRestaurant: function (selectedRestaurant) {
                let params = new URLSearchParams();
                params.append("restaurant_id", selectedRestaurant);
                if(selectedRestaurant !== ""){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        console.log(resp.data);
                        this.selectedRestaurantBranches = resp.data;
                    });
                }else{
                    this.selectedRestaurantBranches = [];
                }
            },
            updateUser: function () {
              this.showLoading();
              if (this.user.id > 0) {
                delete this.user.password;
              }
              if(this.user.id === 0 && this.user.password.length < 6 ){
                swal("TRY AGAIN!", "Password length should be at least of 6 digits!", "error");
                return;
              }
              this.showLoading();
              this.$http.post(this.$store.state.mainAppURL + "users/update_user", this.user).then(resp => {
                if (resp.data) {
                  $("#updateUserModal").modal("hide");
                  swal("Success", "Updated Successfully!", "success");
                } else {
                  swal("Error!", "Username or Contact Number Already registered. Try Again!", "error");
                }
              }).catch(ex => {
                this.showErrorMessage(ex);
              });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call());
            }
        }
    }
</script>

<style scoped>
</style>
